import Vue from 'vue'
import Vuex, {mapGetters, mapActions} from 'vuex'
import {core} from './modules/core'
import {validations} from './modules/validations'
import {companies} from './modules/companies'
import {contracts} from './modules/contracts'
import {contract} from './modules/contract'
import {product} from './modules/product'
import {user} from "~/store/modules/user"


Vue.use(Vuex)

Vue.mixin({
    methods: {
        ...mapActions({setUser: "user/setUser"})
    },
    computed: {
        ...mapGetters({user: "user/getUser"})
    }
})

const actionOnReject = store => {
    store.subscribeAction({
        error: (action, state, error) => {
            Promise.reject(error)
        }
    })
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    plugins: [actionOnReject],
    state: {},
    mutations: {},
    actions: {},
    modules: {
        namespaced: true,
        core,
        validations,
        companies,
        contracts,
        contract,
        product,
        user
    }
})
